module.exports = __webpack_public_path__ + "static/img/bg_default.9add51c1.png";